// Services
import callAPI from "../callApi";
import path from "../variables";

const Passengers = {
	getAll: (param?: any) =>
		callAPI(
			"GET",
			`${path.base}/tickets/passengers${param ? param : ""}`,
			"",
			"getting all passengers"
		),
	getAllTransferred: (param?: any) =>
		callAPI(
			"GET",
			`${path.base}/operation/passengers-transferred-histories${param ? param : ""}`,
			"",
			"getting all transferred passengers"
		),
	getAllDiscountGranted: (param?: any) =>
		callAPI(
			"GET",
			`${path.base}/operations/otp-usage-histories${param ? param : ""}`,
			"",
			"getting all discount passengers granted"
		),
	create: (data: any) =>
		callAPI("POST", `${path.base}/tickets/passengers`, data, "register new passenger"),
	update: (data: any, uuid: string, station: string) =>
		callAPI(
			"PUT",
			`${path.base}/tickets/passengers/${uuid}${station}`,
			data,
			"update passenger info"
		),
	transfers: (data: any) =>
		callAPI(
			"PUT",
			`${path.base}/operation/passengers/transfers`,
			data,
			"transfer passengers process"
		),
	// SeatLayoutPicker — déplacement ou swap d'un siège intra-embarquement.
	// data = { target_seat: number, station_id: number }
	swapSeat: (passengerUuid: string, data: any) =>
		callAPI(
			"PUT",
			`${path.base}/operation/passengers/${passengerUuid}/swap-seat`,
			data,
			"swap or move passenger seat"
		),
	// PR-9 — Contrôle d'embarquement par scan QR. data = { ticket_number, station }.
	// Toggle is_embarked. Backend dispatch SeatChanged broadcast → SeatLayoutPicker
	// se met à jour en temps réel (siège passe rouge→vert au check-in).
	markEmbarkedWithQr: (data: any) =>
		callAPI(
			"PUT",
			`${path.base}/operation/passengers/marked-as-embarked/with-qrcode-verification`,
			data,
			"mark passenger as embarked via QR code"
		),
	getWeeklyTotalStats: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/passengers/totals${filter ? filter : ""}`,
			"",
			"getting total weekly apassengers stats"
		),

	getDailyTotalForCurrentUser: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/passengers/daily-totals-by-current-user${filter ? filter : ""}`,
			"",
			"getting daily passengers stats for current user"
		),
};
;
export default Passengers;
